module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0117.jpg?v=f0634d4e";